<article
    class="booking-choice-row"
    [class.booking-choice-row--grid]="gridLayout()"
    [class.booking-choice-row--event]="choice().kind === 'event'"
    data-testid="booking-choice-row"
>
    @if (imageUrl(); as imageUrl) {
        <img
            [ngSrc]="imageUrl"
            class="booking-choice-image"
            [width]="gridLayout() ? 700 : 92"
            [height]="gridLayout() ? 400 : 92"
            [alt]="displayName()"
        />
    } @else if (choice().kind === 'standard') {
        <div
            class="booking-choice-image-placeholder"
            aria-hidden="true"
        ></div>
    } @else {
        <div
            class="booking-choice-image-placeholder"
            role="img"
            [attr.aria-label]="displayName() + ' image unavailable'"
        >
            <i
                class="bi bi-calendar-event"
                aria-hidden="true"
            ></i>
        </div>
    }

    <div class="booking-choice-content">
        <div class="booking-choice-title">
            <h4 class="h6 fw-semibold m-0">
                {{ displayName() }}
            </h4>
            @if (reasonChoice(); as reasonChoice) {
                @if (reasonChoice.isFull) {
                    <span class="badge bg-dark-subtle text-dark-emphasis lh-sm fw-semibold">
                        Fully booked
                    </span>
                }
            }
        </div>

        @if (reasonChoice(); as reasonChoice) {
            @let configuredOpeningTimes = reasonChoice.reason.displayedOpeningTimes;
            @let scheduledOpeningTimes = reasonChoice.reason.scheduleRules.length > 0
                ? (reasonChoice.reason | reasonTime : date())
                : null;
            @let openingTimes = configuredOpeningTimes ?? scheduledOpeningTimes;
            @if (openingTimes) {
                <span
                    class="booking-choice-time small text-secondary"
                    data-testid="booking-choice-time"
                >
                    <img
                        ngSrc="assets/clock_small.svg"
                        width="20"
                        height="20"
                        alt=""
                        aria-hidden="true"
                    />
                    <span>{{ openingTimes }}</span>
                </span>
            }
        }

        @if (description()) {
            <div
                class="booking-choice-description quill-flush text-secondary"
                data-testid="booking-choice-description"
            >
                <quill-view class="d-block" format="html" theme="bubble" [sanitize]="true" [content]="description()"></quill-view>
            </div>
        }

        @if (choice().cancellationChargesApply || choice().depositRequired) {
            <div class="booking-choice-warnings small fw-semibold d-flex flex-wrap gap-2">
                @if (choice().cancellationChargesApply) {
                    <span data-testid="cancellation-charge-warning">
                        Cancellation charges apply
                    </span>
                }
                @if (choice().depositRequired) {
                    <span data-testid="deposit-required-warning">
                        {{ paymentTerminology().label }} required
                    </span>
                }
            </div>
        }
    </div>

    <button
        type="button"
        class="btn btn-primary booking-choice-action"
        data-testid="select-and-continue"
        [attr.aria-label]="'Select & Continue: ' + displayName()"
        [disabled]="reasonChoice()?.isFull ?? false"
        (click)="choiceSelected.emit(choice())"
    >
        Select &amp; Continue
    </button>
</article>
